import { Typography } from '@mui/material'
import {
  Container, Modal, TipsList, Subtitle, ModalHeader, ModalBody, CloseModalButton, TitleLabel,
} from './ModalInfo.styles'

interface ModalInfoContentProps {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const ModalInfoContent = ({ setIsOpen }: ModalInfoContentProps) => {
  const closeModal = () => setIsOpen(false)

  return (
    <Container>
      <Modal data-testid='info-modal'>
        <ModalHeader>
          <TitleLabel>
            <Typography variant='h5' fontWeight='bold'>Dúvidas</Typography>
          </TitleLabel>
          <CloseModalButton data-testid='close-info-button' onClick={closeModal} />
        </ModalHeader>

        <ModalBody>
          <Subtitle variant='h6'>Como utilizar corretamente a página?</Subtitle>
          <TipsList>
            <li>Bipe <b>TODOS</b> os lotes que deseja adicionar, em sequência;</li>
            <li>Caso o lote esteja em mais de um endereço, selecione o endereço do qual o lote será retirado;</li>
            <li>Bipe a etiqueta do endereço onde será feita a entrada dos lotes;</li>
            <li>Caso necessite alterar o endereço de entrada, bipe a etiqueta do novo endereço;</li>
            <li>Clique em <b>LIMPAR</b> para apagar todas as informações da tela;</li>
          </TipsList>
        </ModalBody>
      </Modal>
    </Container>
  )
}
